import React from "react";
import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import Logo from "./Logo";

export const SiteFooter = () => {
  return (
    <footer
      className="bg-[#2a1f4a] text-white mt-16"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="inline-flex items-center bg-white rounded-2xl p-3 shadow-md shadow-black/10">
            <Logo variant="light" size="default" />
          </div>
          <p className="text-sm text-white/70 mt-5 leading-relaxed max-w-xs">
            Premium bulk fuel distribution, onsite fueling, and fuel cards —
            keeping America's commercial fleets moving since 1988.
          </p>
        </div>

        <div>
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#ecac1f] mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-1 text-[#ecac1f] shrink-0" />
              <div>
                <a
                  href="tel:+18339255065"
                  className="font-semibold hover:text-[#ecac1f] transition-colors"
                  data-testid="footer-phone-link"
                >
                  833-925-5065
                </a>
                <div className="text-xs text-white/60">Call us 24/7</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 text-[#ecac1f] shrink-0" />
              <a
                href="mailto:sales@ricochetfuel.com"
                className="font-semibold hover:text-[#ecac1f] transition-colors break-all"
                data-testid="footer-email-link"
              >
                sales@ricochetfuel.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#ecac1f] shrink-0" />
              <div className="text-white/85">
                1201 Royal Parkway<br />
                Euless, TX 76040
              </div>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#ecac1f] mb-4">
            Quick Links
          </div>
          <ul className="space-y-3 text-sm">
            {[
              { href: "https://www.ricochetfuel.com", label: "Main Website" },
              { href: "https://www.ricochetfuel.com/services", label: "Services" },
              { href: "https://www.ricochetfuel.com/customers", label: "Customer Portal" },
              { href: "https://www.ricochetfuel.com/contact", label: "Contact Us" },
            ].map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#ecac1f] transition-colors"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                  <ExternalLink className="w-3.5 h-3.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <div className="text-white/60">
            © {new Date().getFullYear()} Ricochet Fuel Distributors, Inc. All rights reserved.
          </div>
          <div
            className="italic font-bold tracking-wide"
            style={{ color: "#ecac1f" }}
          >
            We Keep You Moving!
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
